import { render } from "./LoadSheet.vue?vue&type=template&id=506549de&scoped=true"
import script from "./LoadSheet.vue?vue&type=script&lang=js"
export * from "./LoadSheet.vue?vue&type=script&lang=js"

import "./LoadSheet.vue?vue&type=style&index=0&id=506549de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Top\\Work\\Impelos\\Repos\\load-manager\\loadSheet\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506549de"]])

export default __exports__